import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-data-card',
  templateUrl: './fc-data-card.component.html',
  styleUrls: ['./fc-data-card.component.scss']
})
export class FcDataCardComponent {

  @Input()
  title: string;

  @Input()
  color: string;

  @Input()
  info: string;

  @Input()
  seeMore = false;

  @Input()
  description: string;

  @Input()
  value: number;

  @Input()
  isLoading: boolean;

  @Output()
  clickSeeMore = new EventEmitter<void>();

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}
